import React from "react";
import { VISITS_URL_V2 } from '../constants/patientChart.constant';

export default class Handshake extends React.Component {
    componentDidMount() {
        if (URLSearchParams) {
            let { location, history } = this.props;
            let queryString = new URLSearchParams(location.search);
            let CompanyID = queryString.get("CompanyID");
            let Token = queryString.get("Token");
            let UserID = queryString.get("UserID");
            let userData = { CompanyID, Token, UserID };
            localStorage.setItem("userData", JSON.stringify(userData));
            localStorage.setItem("userId", userData.UserID);
            localStorage.setItem('ppLastSavedTime', new Date());
            history && history.push(VISITS_URL_V2);
        }
    }
    render() {
        return null;
    }
}
